module.exports = __webpack_public_path__ + "static/media/house-of-diamonds.feeb0d43.png";